import { render } from "./MerchantManagement.vue?vue&type=template&id=f5a82bf2&scoped=true"
import script from "./MerchantManagement.vue?vue&type=script&lang=js"
export * from "./MerchantManagement.vue?vue&type=script&lang=js"

import "./MerchantManagement.vue?vue&type=style&index=0&id=f5a82bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a82bf2"]])

export default __exports__